import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "createCompanyActivity",
    serviceName: "admin",
    query: gql`
      mutation createCompanyActivity($title: String!, $details: String) {
        createCompanyActivity(title: $title, details: $details) {
          messages
        }
      }
    `,
  },
};

export default schema;
